import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=33bf9ba0&scoped=true"
import script from "./LoadingSpinner.ts?vue&type=script&lang=ts&external"
export * from "./LoadingSpinner.ts?vue&type=script&lang=ts&external"
import style0 from "./LoadingSpinner.scss?vue&type=style&index=0&id=33bf9ba0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf9ba0",
  null
  
)

export default component.exports